import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { environment } from '../../../environments/environment';
import { CommonDataService } from '../common-data.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { FsCsvExportService, FsCsvGroup } from '../common/fs-csv-export/fs-csv-export.service';

@Injectable({
  providedIn: 'root'
})
export class RosterServiceService {

  clarifier_low:number = 0;
  clarifier_high:number = 0;
  ideator_low:number = 0;
  ideator_high:number = 0;
  developer_low:number = 0;
  developer_high:number = 0;
  implementor_low:number = 0;
  implementor_high:number = 0;
  clarifier_neutral:number = 0;
  ideator_neutral:number = 0;
  developer_neutral:number = 0;
  implementor_neutral:number =0;
  integrator:number = 0;
  highest_score:number = 0;
  total_members:number = 0;
  date;
  args:any;
  mockupReportMemLen = 0;
  mockupReportArgs; //mockup report
  ngrxAccount: any;
  team_advice;
  team_lead = {
    name: "",
    profile_title: "",
    profile_type: "",
    profile_type_id: null
  };
  
  constructor( public store: Store<any>, public http: HttpClient, public cmnService: CommonDataService,
               private csv: FsCsvExportService ) { }

    public async setGraphData(currentTeam) {
    // Reset counters to avoid stale accumulated data from previous team selection
    this.clarifier_low = 0;
    this.clarifier_high = 0;
    this.ideator_low = 0;
    this.ideator_high = 0;
    this.developer_low = 0;
    this.developer_high = 0;
    this.implementor_low = 0;
    this.implementor_high = 0;
    this.clarifier_neutral = 0;
    this.ideator_neutral = 0;
    this.developer_neutral = 0;
    this.implementor_neutral = 0;
    this.integrator = 0;
    this.highest_score = 0;

    this.total_members = currentTeam.memberships_count;
    currentTeam?.memberships?.forEach(list => {
        if(list?.default_profile){
            if(list?.default_profile?.clarifier_score == 'Low'){
                this.clarifier_low = this.clarifier_low + 1;
                if( this.clarifier_low > this.highest_score ){
                    this.highest_score = this.clarifier_low;
                }
            }
  
            if(list?.default_profile?.clarifier_score == 'High'){
                this.clarifier_high = this.clarifier_high + 1;
                if( this.clarifier_high > this.highest_score ){
                    this.highest_score = this.clarifier_high;
                }
            }
  
            if(list?.default_profile.ideator_score == 'Low'){
                this.ideator_low = this.ideator_low + 1;
                if( this.ideator_low > this.highest_score ){
                    this.highest_score = this.ideator_low;
                }
            }
  
            if(list?.default_profile?.ideator_score == 'High'){
                this.ideator_high = this.ideator_high + 1;
                if( this.ideator_high > this.highest_score ){
                    this.highest_score = this.ideator_high;
                }
            }
  
            if(list?.default_profile.developer_score == 'Low'){
                this.developer_low = this.developer_low + 1;
                if( this.developer_low > this.highest_score ){
                    this.highest_score = this.developer_low;
                }
            }
  
            if(list?.default_profile?.developer_score == 'High'){
                this.developer_high = this.developer_high + 1;
                if( this.developer_high > this.highest_score ){
                    this.highest_score = this.developer_high;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'Low'){
                this.implementor_low = this.implementor_low + 1;
                if( this.implementor_low > this.highest_score ){
                    this.highest_score = this.implementor_low;
                }
            }
  
            if(list?.default_profile?.implementer_score == 'High'){
                this.implementor_high = this.implementor_high + 1;
                if( this.implementor_high > this.highest_score ){
                    this.highest_score = this.implementor_high;
                }
            }
  
            //   neutral profiles
            if(list?.default_profile?.clarifier_score == 'Neutral') {
              this.clarifier_neutral += 1; 
            }
            if(list.default_profile.ideator_score == 'Neutral') {
              this.ideator_neutral += 1; 
            }
            if(list.default_profile.developer_score == 'Neutral') {
              this.developer_neutral += 1; 
            }
            if(list.default_profile.implementer_score == 'Neutral') {
              this.implementor_neutral += 1; 
            }
            if(list?.default_profile?.clarifier_score == 'Neutral' && list.default_profile.ideator_score == 'Neutral' && list.default_profile.developer_score == 'Neutral' && list.default_profile.implementer_score == 'Neutral'){
              this.integrator += 1;
            }
  
        }
  
    });
    // await this.setArgs(currentTeam)
    this.date = new Date();
    let name = currentTeam.name;
    let membershipcount = currentTeam.memberships_count;
    let org_id = currentTeam.organization_id;
    let org_name = currentTeam.organization_name;
    let date = String(this.date.getFullYear()) + String((this.date.getMonth() + 1)) + String(this.date.getDate());
    let time = String(this.date.getHours()) + String(this.date.getMinutes());
    this.args = {
      "function_name": "plus-GroupProfileFunction-6y5p4TgXuqZA",
      "invocation_type": "RequestResponse",
      "log_type": "None",
      "id": currentTeam.id,
      "template": "team_pf.html",
      "filename": org_name +'-' + currentTeam.id+ '-' + date + time,
      "memberships_count": membershipcount,
      "name": name,
      "organization_title": "Organization",
      "organization_id": org_id,
      "organization_name": org_name,
      "clarifier_low": this.clarifier_low ? this.clarifier_low : 0,
      "clarifier_neutral": this.clarifier_neutral ? this.clarifier_neutral : 0,
      "clarifier_high": this.clarifier_high ? this.clarifier_high : 0,
      "ideator_low": this.ideator_low ? this.ideator_low : 0,
      "ideator_neutral": this.ideator_neutral ? this.ideator_neutral : 0,
      "ideator_high": this.ideator_high ?  this.ideator_high : 0,
      "developer_low": this.developer_low ? this.developer_low : 0,
      "developer_neutral": this.developer_neutral ? this.developer_neutral : 0,
      "developer_high": this.developer_high ? this.developer_high : 0,
      "implementor_low": this.implementor_low ? this.implementor_low : 0,
      "implementor_neutral": this.implementor_neutral ? this.implementor_neutral : 0,
      "implementor_high": this.implementor_high ? this.implementor_high : 0,
      "integrator": this.integrator ?  this.integrator : 0,
      "highest_score": this.highest_score ? this.highest_score : 0,
      "app_type": "Group Profile Plus",
      "pdf_type": "letter",
      "email": "sarah@blairmiller.com",
      // "today_date": this.date,
      "content_type": 'pdf',
      "profile_type": "Ask",
      "description": "Look at your graph. What do you notice? What, if anything, is surprising? Where does this group need to pay deliberate attention so they can succeed? Think of a project or a challenge this group has recently been engaged in. Describe how the group approached the project using the group profile as a guide.",
      "footer_imptext": "FourSight® Group Profile",
      "footer_text": "provides a snapshot of how a group's energy will likely rise and fall as people work together through the four stages of the universal problem solving process. The numbers indicate how many individuals in the group have a high, neutral, or low thinking preference for each stage.",
      "remember": "Preference <span>=</span> Energy",
      "team_des": "FourSight is a measure of thinking preference, not ability. A preference is a measure of energy, not talent. People with a high preference tend to gravitate to that stage of the problem-solving process. People with a low preference tend to move quickly through it. People with a neutral preference tend to do the work and move on. All three approaches can lead to problem-solving success. Teams are more likely to succeed when people are both self-aware and process aware.",
      "footer_des": null,
    }
    console.log("args for team", this.args)
    return this.args;
  }

  // mockup team report
  public async mockupTeamReport(currentTeam, skipAdvice = false) {
    // Reset counters to avoid stale accumulated data
    this.clarifier_low = 0;
    this.clarifier_high = 0;
    this.ideator_low = 0;
    this.ideator_high = 0;
    this.developer_low = 0;
    this.developer_high = 0;
    this.implementor_low = 0;
    this.implementor_high = 0;
    this.clarifier_neutral = 0;
    this.ideator_neutral = 0;
    this.developer_neutral = 0;
    this.implementor_neutral = 0;
    this.integrator = 0;
    this.highest_score = 0;
    this.mockupReportMemLen = 0;
    this.team_lead = { name: "", profile_title: "", profile_type: "", profile_type_id: null };

    // Find team lead across ALL memberships (not just the first 20)
    // The lead may not be among the first 20 members truncated for the report
    const leadMember = currentTeam?.memberships?.find(m => m?.membership_role_id == 4);
    if (leadMember) {
      this.team_lead.name = this.cmnService.userName(leadMember, 'first_name');
      this.team_lead.profile_title = leadMember?.default_profile?.profile_title || "";
      this.team_lead.profile_type = leadMember?.default_profile?.profile_title || "";
      this.team_lead.profile_type_id = leadMember?.default_profile?.profile_type_id || null;
    }

    var clNeu = [];
    var clLow = [];
    var clHigh = [];
    var idNeu = [];
    var idLow = [];
    var idHigh = [];
    var deNeu = [];
    var deLow = [];
    var deHigh = [];
    var imNeu = [];
    var imLow = [];
    var imHigh = [];
    var integrator = [];
    var teamMem = [];
    let all_user_profiles=[];
    let profile_data:any;
    this.ngrxAccount = this.store.select<any>((state) => state.profile.account);
    this.ngrxAccount.subscribe(async (res) => {
      console.log('ngrxAccount', res)
      profile_data = res.default_profile;
    });
    currentTeam?.memberships?.forEach(list => {
        if(this.mockupReportMemLen < 20) {

          if(list){
              all_user_profiles.push(list)
              this.mockupReportMemLen += 1;
              // team_lead is now set above the forEach loop so it works even when lead is beyond the 20-member cap
              teamMem.push(
                {
                  "name": list.first_name ? list.first_name : 'No name',
                  "last_name": list.last_name ? list.last_name : 'No name',
                  "profile_title": (list?.default_profile?.profile_title)?.toLowerCase(),
                  "profile_type_id": list?.default_profile?.profile_type_id
                }
              );
              if(list?.default_profile?.clarifier_score == 'Low'){
                clLow.push(this.cmnService.userName(list,'first_name'));
                this.clarifier_low = this.clarifier_low + 1;
              }
    
              if(list?.default_profile?.clarifier_score == 'High'){
                clHigh.push(this.cmnService.userName(list,'first_name'));
                this.clarifier_high = this.clarifier_high + 1;
              }
    
              if(list?.default_profile?.ideator_score == 'Low'){
                idLow.push(this.cmnService.userName(list,'first_name'));
                this.ideator_low = this.ideator_low + 1;
              }
    
              if(list?.default_profile?.ideator_score == 'High'){
                idHigh.push(this.cmnService.userName(list,'first_name'));
                this.ideator_high = this.ideator_high + 1;
              }
    
              if(list?.default_profile?.developer_score == 'Low'){
                deLow.push(this.cmnService.userName(list,'first_name'));
                this.developer_low = this.developer_low + 1;
              }
    
              if(list?.default_profile?.developer_score == 'High'){
                deHigh.push(this.cmnService.userName(list,'first_name'));
                this.developer_high = this.developer_high + 1;
              }
    
              if(list?.default_profile?.implementer_score == 'Low'){
                imLow.push(this.cmnService.userName(list,'first_name'));
                this.implementor_low = this.implementor_low + 1;
              }
    
              if(list?.default_profile?.implementer_score == 'High'){
                imHigh.push(this.cmnService.userName(list,'first_name'));
                this.implementor_high = this.implementor_high + 1;
              }
    
              //   neutral profiles
              if(list?.default_profile?.clarifier_score == 'Neutral') {
                clNeu.push(this.cmnService.userName(list,'first_name'));
                this.clarifier_neutral += 1; 
              }
              if(list?.default_profile?.ideator_score == 'Neutral') {
                idNeu.push(this.cmnService.userName(list,'first_name'));
                this.ideator_neutral += 1; 
              }
              if(list?.default_profile?.developer_score == 'Neutral') {
                deNeu.push(this.cmnService.userName(list,'first_name'));
                this.developer_neutral += 1; 
              }
              if(list?.default_profile?.implementer_score == 'Neutral') {
                imNeu.push(this.cmnService.userName(list,'first_name'));
                this.implementor_neutral += 1; 
              }
              if(list?.default_profile?.clarifier_score == 'Neutral' && list.default_profile.ideator_score == 'Neutral' && list.default_profile.developer_score == 'Neutral' && list.default_profile.implementer_score == 'Neutral'){
                this.integrator += 1;
              }
    
          }
        }
        // mockup team member
        
    });

    this.team_advice = skipAdvice ? null : await firstValueFrom(this.http.get(`${environment.profileURL}/api/v1/team_advices/${currentTeam.id}.json`)).catch(() => null);

    this.date = new Date();
    let name = currentTeam.name;
    let membershipcount = currentTeam.memberships_count;
    let org_id = currentTeam.organization_id;
    let org_name = currentTeam.organization_name;
    let date = String(this.date.getFullYear()) + String((this.date.getMonth() + 1)) + String(this.date.getDate());
    let time = String(this.date.getHours()) + String(this.date.getMinutes());
    this.mockupReportArgs = {
      "function_name": "plus-GroupProfileFunction-6y5p4TgXuqZA",
      "invocation_type": "RequestResponse",
      "log_type": "None",
      "id": currentTeam.id,
      "template": "team_pf.html",
      "filename": org_name +'-' + currentTeam.id+ '-' + date + time,
      "memberships_count": membershipcount,
      "name": name,
      "first_name": profile_data?.first_name ? profile_data?.first_name : '',
      "last_name": profile_data?.last_name ? profile_data?.last_name : '',
      "organization_title": "Organization",
      "organization_id": org_id,
      "organization_name": org_name,
      "team_name": currentTeam.name,
      "app_type": "Group Profile Plus",
      "pdf_type": "letter",
      "email": profile_data?.email ? profile_data?.email : '',
      // "today_date": this.date,
      "clarifier_sum": profile_data?.clarifier_sum ? profile_data?.clarifier_sum : '',
      "developer_sum": profile_data?.developer_sum ? profile_data?.developer_sum : '',
      "ideator_sum": profile_data?.ideator_sum ? profile_data?.ideator_sum : '',
      "implementer_sum": profile_data?.implementer_sum ? profile_data?.implementer_sum : '',
      "low_contrast": profile_data?.low_contrast ? profile_data?.low_contrast : '',
      "high_contrast": profile_data?.high_contrast ? profile_data?.high_contrast : '',
      "content_type": 'pdf',
      "profile_type": "Ask",
      "description": "Look at your graph. What do you notice? What, if anything, is surprising? Where does this group need to pay deliberate attention so they can succeed? Think of a project or a challenge this group has recently been engaged in. Describe how the group approached the project using the group profile as a guide.",
      "footer_imptext": "FourSight® Group Profile",
      "footer_text": "provides a snapshot of how a group's energy will likely rise and fall as people work together through the four stages of the universal problem solving process. The numbers indicate how many individuals in the group have a high, neutral, or low thinking preference for each stage.",
      "remember": "Preference <span>=</span> Energy",
      "team_des": "FourSight is a measure of thinking preference, not ability. A preference is a measure of energy, not talent. People with a high preference tend to gravitate to that stage of the problem-solving process. People with a low preference tend to move quickly through it. People with a neutral preference tend to do the work and move on. All three approaches can lead to problem-solving success. Teams are more likely to succeed when people are both self-aware and process aware.",
      "footer_des": null,
      "all_user_profiles": all_user_profiles,
      "team_profiles": {
        "clarifier_low": this.clarifier_low ? this.clarifier_low : 0,
        "clarifier_neutral": this.clarifier_neutral ? this.clarifier_neutral : 0,
        "clarifier_high": this.clarifier_high ? this.clarifier_high : 0,
        "ideator_low": this.ideator_low ? this.ideator_low : 0,
        "ideator_neutral": this.ideator_neutral ? this.ideator_neutral : 0,
        "ideator_high": this.ideator_high ?  this.ideator_high : 0,
        "developer_low": this.developer_low ? this.developer_low : 0,
        "developer_neutral": this.developer_neutral ? this.developer_neutral : 0,
        "developer_high": this.developer_high ? this.developer_high : 0,
        "implementer_low": this.implementor_low ? this.implementor_low : 0,
        "implementer_neutral": this.implementor_neutral ? this.implementor_neutral : 0,
        "implementer_high": this.implementor_high ? this.implementor_high : 0,
        "integrator": this.integrator ?  this.integrator : 0,
        "highest_score": this.highest_score ? this.highest_score : 0,
      },
      "gppData": {
        "clHigh": clHigh,
        "clLow": clLow,
        "clNeu": clNeu,
        "idHigh": idHigh,
        "idLow": idLow,
        "idNeu": idNeu,
        "deHigh": deHigh,
        "deLow": deLow,
        "deNeu": deNeu,
        "imHigh": imHigh,
        "imLow": imLow,
        "imNeu": imNeu,
      },
      "table_member": teamMem,
      "team_lead": this.team_lead,
      // "team_lead": {
      //     "name": "Alex Ham",
      //     "profile_title": "clarifier"
      // },
      "team_advice_high_energy": this.team_advice?.high,
      "team_advice_low_energy": this.team_advice?.low,
      "team_advice_watchouts": (this.team_advice?.tug_of_war ? this.team_advice.tug_of_war + '<br>' : '') + (this.team_advice?.minority_high ? this.team_advice.minority_high : ''),
    }
    console.log("mockup report args for team", this.mockupReportArgs)
    return this.mockupReportArgs;
  }

  public setArgs(currentTeam) {
  }

  public downloadTeamsCsv(teams: any[], rosterName: string, format: string): void {
    // The roster's API returns a name on any of three shapes depending on the endpoint that
    // produced the row, so the fallback chain stays here — it describes this API, not CSV.
    const getMemberName = (member: any, field: 'first_name' | 'last_name'): string => {
      return member?.[field]
        || member?.default_identity?.[field]
        || member?.default_profile?.[field]
        || '';
    };

    const groups: FsCsvGroup[] = (teams ?? []).map(team => ({
      name: team.name || '',
      members: (team.memberships || []).map((member: any) => ({
        firstName: getMemberName(member, 'first_name'),
        lastName: getMemberName(member, 'last_name'),
      })),
    }));

    this.csv.download(groups, {
      // Anything that isn't 'grouped' is flat — matches the previous if/else exactly. The modal
      // only ever emits 'flat' or 'grouped'.
      format: format === 'grouped' ? 'grouped' : 'flat',
      groupColumnHeader: 'Team',
      filename: rosterName || 'teams',
    });
  }

  public showError(error: any): void {
    if (error.status == 500) {
      Swal.fire({ title: 'Sorry!', text: 'Something went wrong!', icon: 'error', timer: 2000, showConfirmButton: false });
    } else if (error.status == 422) {
      Swal.fire({ title: 'Oops!', text: error.error.errors, icon: 'error', timer: 4000, showConfirmButton: false });
    } else if (error.status == 406) {
      Swal.fire({ title: 'Oops!', text: error.error.errors, icon: 'error', timer: 4000, showConfirmButton: false });
    } else {
      Swal.fire({ title: 'Oops!', text: 'Something went wrong!', icon: 'error', timer: 2000, showConfirmButton: false });
    }
  }

}